import { Box } from '@mui/system'
import { IconButton, FormControl, Select, TextField,  MenuItem, FormHelperText, ListItemText, Checkbox, Button } from '@mui/material'
import { Translate, translate } from 'react-i18nify';
import { useState, useEffect } from 'react'
import { LocationService } from '../../../services/DataService';
import { Typography } from '@mui/material';
import SyncIcon from '@mui/icons-material/Sync';
import BuildIcon from '@mui/icons-material/Build';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import InstallerLookupFilterExplainer from './InstallerLookupFilterExplainer';
import LocalStorageManager from '../../../utils/LocalStorageManager';



export default function InstallerLookup(props) {

    const [locations, setLocations] = useState([]);
    const [o2maticIdError, setO2maticIdError] = useState(false);
    const [o2maticId, setO2maticId] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [address, setAddress] = useState("");
    const [locationId, setLocationId] = useState(null);
    const [active, setActive] = useState(true);
    const [disableSearch, setDisableSearch] = useState(false)
    const [disableClearFilters, setDisableClearFilters] = useState(false)


    useEffect(() => {
        (async () => {
            let apiResult = await LocationService.getAll();
            setLocations(apiResult.data.sort((a, b) => a.name > b.name ? 1 : -1));
        })();
    }, []);

    useEffect(() => {
        checkIsQueryEmpty()
    },[o2maticId, firstName, lastName, address, locationId])

    useEffect(() => {
        checkIsFilterEmpty()
    },[props.remarks, props.updateOptions])

    useEffect(() => {
        if(locations.length > 0)
            setLocationId(LocalStorageManager.getItemFromStorage("locationId"))
    },[locations])

    const handleLocationChange = (event) => {
        setLocationId(event.target.value);
        LocalStorageManager.saveLocalStoarge("locationId", event.target.value)
    }

    const handleDfuChange = (event) => {
        props.setDfu(event.target.value);
    }

    const handleRemarkChange = (event) => {
        let remarksCopy = props.remarks.map((remark) => {
            const newValue = event.target.value.find((item) => item.name === remark.name);
            if(remark.name === newValue?.name){
                remark.filtered = true;
            }else{
                remark.filtered = false;
            }
            return remark;
        })
        props.setRemarks(remarksCopy);  
    }

    const handleUpdateOptionChange = (event) => {
        let updateOptionsCopy = props.updateOptions.map((option) => {
            const newValue = event.target.value.find((item) => item.name === option.name);
            if(option.name === newValue?.name){
                option.filtered = true;
            }else{
                option.filtered = false;
            }
            return option;
        })
        props.setUpdateOptions(updateOptionsCopy);  

    }

    const activeHandler = (event) => {
        setActive(event.target.checked)
    }

    const handleSubmit = async (event) => {
        var data = event.target;

        event.preventDefault();

        var query = {}

        if (data?.o2maticId?.value || o2maticId) {
            if (!isNaN(data?.o2maticId?.value) || !isNaN(o2maticId)) {
                query._id = data?.o2maticId?.value;
                setO2maticIdError(false);
            }else{
                setO2maticIdError(true);
            }
        }
        if (firstName != "") {
            query.firstName = firstName;
        }
        if (lastName != "") {
            query.lastName = lastName;
        }
        if(address != ""){
            query.address = address;
        }
        if (locationId) {
            query.locationId = locationId;
        }
        // if(Object.keys(query).length > 0)
        props.handleSearchQuery(query);
    }

    const checkIsQueryEmpty = () => {
        if (firstName != "" || lastName != "" || address != "" || locationId || o2maticId) { 
            setDisableSearch(false)
        }else{
            setDisableSearch(true)
        }
    }

    const checkIsFilterEmpty = () => {
        const activeRemark = props.remarks.find(r => r.filtered === true)
        const activeOption = props.updateOptions.find(o => o.filtered === true)
        if(activeRemark != undefined || activeOption != undefined){
            setDisableClearFilters(false)
        }else 
            setDisableClearFilters(true);
    }

    const handleClearFilters = (event) => {
        event.preventDefault();
        props.setUpdateOptions((options) => {
            const newOptions = options.map(op =>{
                op.filtered = false
                return op
            })
            return newOptions
        })
        props.setRemarks((remarks) => {
            const clearFilters = remarks.map(r => {
                r.filtered = false
                return r
            })
            return clearFilters;
        })

    }


    const handleClearSearch = (event) => {
        event.preventDefault();
        setO2maticIdError(false)
        setLocationId(null)
        setFirstName("")
        setLastName("")
        setAddress("")
        setO2maticId("")
        props.getOverview(false);
    }

    const inputFieldsWidths = {
        o2maticId: {
            outerWidth: "15%",
            innerWidth: "90%"
        } ,
        firstName: {
            outerWidth: "20%",
            innerWidth: "90%"
        },
        lastName: {
            outerWidth: "20%",
            innerWidth: "90%"
        },
        address: {
            outerWidth: "20%",
            innerWidth: "90%"
        },
        location: {
            outerWidth: "25%",
            innerWidth: "90%"
        },
        remark:  {
            outerWidth: "50%",
            innerWidth: "90%"
        },
        dfu: {
            outerWidth: "50%",
            innerWidth: "100%"
        },
    }

    return (
        <>
        <Box sx={{ display: "flex", flexDirection: "column", width: { xs: "100%", sm: "100%", md: "100%", lg: "1500px" }}}
            component="form" onSubmit={handleSubmit}
        >
            {
                props.loadingO2maticUser ? 
                <></> 
                :
                props.isO2maticUser ?
                <></>
                :
                <Box>
                    <Box>
                        <Typography variant="h6"><Translate value='InstallerSearch' /></Typography>
                    </Box>

                    <Box id="BigBox" variant="form" sx={{ mt: 1, display: "flex", flexDirection: "row", width:"100%", minHeight:"75px"}} >
                            <FormControl id="form" variant="standard" sx={{ display: "flex", flexDirection: "row", }}>      
                            <Box sx={{ display: "flex", flexDirection: "row", backgroundColor:"secondary.lightest",  borderRadius:1, }} id="tyinh" >
                                <Box id="Grey" sx={{ backgroundColor:"secondary.lightest", display:"flex", flexDirection: "row", borderRadius:1}} >
                                    <Box  sx={{ my:1, ml:2, width: inputFieldsWidths.o2maticId.outerWidth, mr:2, color:"#9F9F9F", display:"flex", flexDirection: "column",justifyContent: "flex-end"}}  >
                                        <Translate value="O2maticId" />
                                        <TextField
                                            id="o2maticId"
                                            defaultValue=""
                                            sx={{ width: inputFieldsWidths.o2maticId.innerWidth}}
                                            variant="standard"
                                            error={o2maticIdError}
                                            value={o2maticId}
                                            helperText={o2maticIdError ? <FormHelperText><Translate value="InvalidValue"/></FormHelperText> : null}
                                            onChange={(event) => setO2maticId(event.target.value)}
                                            />
                                    </Box>     
                                    <Box sx={{ m:1, width: inputFieldsWidths.firstName.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column",justifyContent: "flex-end"}}>
                                        <Translate value="FirstName" />
                                        <TextField
                                            sx={{ width: inputFieldsWidths.firstName.innerWidth}}
                                            id="firstName"
                                            defaultValue=""
                                            variant="standard" 
                                            value={firstName}
                                            onChange={(event) => setFirstName(event.target.value)}
                                            />
                                    </Box>
                                    <Box sx={{m:1, width: inputFieldsWidths.lastName.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column",justifyContent: "flex-end"}}>
                                        <Translate value="LastName" />
                                        <TextField
                                        sx={{ width: inputFieldsWidths.lastName.innerWidth}}
                                        id="lastName"
                                        defaultValue=""
                                        variant="standard" 
                                        value={lastName}
                                        onChange={(event) => setLastName(event.target.value)}
                                        />
                                    </Box>
                                    <Box sx={{m:1, width: inputFieldsWidths.address.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column",justifyContent: "flex-end"}}>
                                        <Translate value="Address"/>
                                        <TextField
                                        sx={{ width: inputFieldsWidths.address.innerWidth}}
                                        id="address"
                                        defaultValue=""
                                        variant="standard" 
                                        value={address}
                                        onChange={(event) => setAddress(event.target.value)}
                                        />
                                    </Box>
                                    <Box sx={{m:1, mr:0, width: inputFieldsWidths.location.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column",justifyContent: "flex-end"}}>
                                        <Translate value="Location"/>
                                        <Select
                                            sx={{ width: inputFieldsWidths.location.innerWidth}}
                                            select
                                            value={locationId}
                                            variant="standard"
                                            onChange={handleLocationChange}
                                            >
                                            <MenuItem value={""}><Translate value="None"/></MenuItem>
                                            {locations.map(location => {
                                                return <MenuItem key={location.id} value={location.id}>{location.name}</MenuItem>
                                            })}
                                        </Select>
                                    </Box>
                                </Box>
                                
                                <Box id="buttonBox" sx={{ display:"flex", flexDirection: "row", mt:1, mr:2 }} >
                                    <Box sx={{ alignSelf:"center", m:1.25}}>
                                        <Button
                                        type="submit"
                                        variant="contained"
                                        disabled={disableSearch}
                                        >
                                            <Typography> <Translate value="Search"/> </Typography>
                                        </Button>
                                    </Box>
                                    <Box sx={{ alignSelf:"center", color:"secondary.main" }} >
                                        <Button onClick={handleClearSearch} variant="outlined" disabled={!props.searched} > 
                                            <Typography> <Translate value="ClearSearch"/> </Typography>
                                        </Button>
                                    </Box>
                                </Box>
                            </Box>
                            </FormControl>
                    </Box>
                </Box>
            }
            <Box sx={{ mt: 2, display:"flex", flexDirection: "row", width:  { md: "100%", lg: "1298px"}, height: { lg: "100px" }, border:1, borderBottom: 0, borderRadius:"10px 10px 0px 0px", borderColor: "black"}} >
                <Box sx={{ display:"flex", flexDirection: "row", width:"60%", mt:1 , mr:1, justifyContent: 'space-between', alignItems: 'flex-end', flexGrow:1}} > 
                    <Box sx={{width: inputFieldsWidths.remark.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column", m:1, ml:2, mb:2, }}>
                        <Box sx={{ display:"flex", flexDirection: "row" }} >
                            
                                <Translate value="Remark"/>
                            
                            <Box sx={{ml:1}} >
                                <InstallerLookupFilterExplainer remarks={props.remarks} />
                            </Box>
                        </Box>
                        <Select
                        variant='standard'
                            sx={{ width: inputFieldsWidths.remark.innerWidth}}
                            labelId="remark"
                            multiple
                            id="remark"
                            value={props.remarks.filter(remark => remark.filtered === true)}
                            onChange={handleRemarkChange}
                            renderValue={(selected) =>  {
                                let rolesString = "";
                                selected.forEach(remark => {
                                    rolesString += remark.filtered ? remark.value + ", " : "";
                                });
                                return rolesString
                            }}
                            >
                            {props.remarks.map(remark => {
                                return <MenuItem key={remark.id} value={remark}>
                                    <Checkbox checked={remark.filtered} />
                                    <ListItemText primary={translate(remark.name)} />
                                    </MenuItem>
                            })}
                        </Select>
                    </Box>
                    <Box sx={{width: inputFieldsWidths.dfu.outerWidth, color:"#9F9F9F", display:"flex", flexDirection: "column" , m:1, mb:2 }}>
                        <Translate value="SWServiceUpToDateAva" />
                        <Select
                            variant='standard'
                            sx={{ width: inputFieldsWidths.dfu.innerWidth, mr: 2, mt:0.8}}
                            labelId="updateOptions"
                            multiple
                            id="updateOptions"
                            value={props.updateOptions.filter(option => option.filtered === true)}
                            onChange={handleUpdateOptionChange}
                            renderValue={(selected) =>  {
                                let rolesString = "";
                                selected.forEach(option => {
                                    rolesString += option.filtered ? option.value + ", " : "";
                                });
                                return rolesString
                            }}
                            >
                            {props.updateOptions.map(option => {
                                return <MenuItem key={option.id} value={option}>
                                    <Checkbox checked={option.filtered} />
                                    <ListItemText primary={option.value} />
                                    {option.name === "SWUpdate" ? <SyncIcon/> : option.name === "Service" ? <BuildIcon/> : <></> }
                                    </MenuItem>
                            })}
                        </Select>
                    </Box>
                    <Box sx={{ minWidth:"30px", width:"10px", mb:1 }} >
                        <IconButton onClick={handleClearFilters} disabled={ disableClearFilters } variant="text" color='primary' > 
                            <FilterAltOffIcon/>
                        </IconButton>
                    </Box>
                </Box>
                <Box sx={{ minWidth: "20%", display:"flex", flexDirection: "column",alignContent: 'flex-end', mx: 4, mt:1.5}} >
                    <Box sx={{display:"flex", flexDirection: "row", alignItems: 'center', mb:1,  mt: 1.2, alignContent: 'flex-end' }} >
                        <SyncIcon/>
                        <Typography>
                            : <Translate value='UpdateLegend.Sw'/>
                        </Typography>
                    </Box>
                    <Box sx={{display:"flex", flexDirection: "row", alignItems: 'center', mb:1 }}>
                        <BuildIcon/>
                        <Typography>
                            : <Translate value='UpdateLegend.Service'/>
                        </Typography>                        
                    </Box>
                </Box>
            </Box>
        </Box>
        </>
    )
}
                                        {/* <IconButton
                                        type="submit"
                                        variant="contained"
                                        disabled={disableSearch}
                                        >
                                            <SearchIcon sx={{color: "#FFFFFF"}}/>
                                        </IconButton> */}